import { SidebarSide } from '../../../pocos/sidebar.class';
import { ISidebarModule } from './sidebar-modul.interface';

export interface ISidebarManagerComponent {
    integrationModules: ISidebarModule[];
    integrationId: string;

    sharedModules: ISidebarModule[];

    reinitSidebars(): void;
    showSidebars(): void;
    reinitModules(): void;
    shouldSkipSharedModule(moduleClass: new () => ISidebarModule): void;
    removeModules(): void;
    ensureSidebarModules(): void;
    dockTo(newSide: SidebarSide, oldSide: SidebarSide): void;
    resize(side: SidebarSide, size: number): void;
}
